import type { Dispatchable } from '../../../../interfaces/Dispatchable';
import EventNames from '../../../../constants/DataLayer/EventNames';

export default class DataLayerEvent implements Dispatchable {
  element: ?HTMLElement;
  data: ?Object;

  /**
     * Create a new instance of a DataLayerEvent
     *
     * Always get a fresh element without references,
     * so if there interactions, it will not pollute our datalayer data
     */
  constructor(data: ?Object, element: ?HTMLElement) {
    this.data = data;
    this.element = element?.cloneNode(true) || null;
  }

  /**
     * @inheritDoc
     */
  validate(): boolean {
    return true;
  }

  /**
     * @inheritDoc
     */
  dispatch(): void {
    window.dataLayer.push({ ecommerce: null, insider: null });
  }

  /**
     * Push an event to the datalayer
     */
  push(data: Object): void {
    window.dataLayer.push(data);
  }
}
